import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IMetadataPostMetadata } from "shared/components/organisms/AppNotification/@types/postTypes";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { PrivateNotificationContainer } from "./styles";

interface IPrivateNotificationProps {
  notification: INotification<IMetadataPostMetadata>;
}

export const PrivateNotification = ({
  notification,
}: IPrivateNotificationProps) => {
  return (
    <PrivateNotificationContainer>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          <Notification.UserPhoto
            photoSrc={notification?.metadata?.commenter?.photo}
            username={notification?.metadata?.commenter?.display_name}
            showLockIcon
          />
        </Notification.IllustrationContainer>

        <Notification.Title.Container>
          <Notification.Title.Highlight>
            {notification?.metadata?.commenter?.display_name}
          </Notification.Title.Highlight>

          <Notification.Title.Text>
            respondeu seu comentário privado: &quot;
            {notification?.metadata?.replied_on?.content}&quot;
          </Notification.Title.Text>
        </Notification.Title.Container>

        <Notification.Content.Container>
          <Notification.Content.Text>
            {notification?.metadata?.comment?.comment}
          </Notification.Content.Text>
        </Notification.Content.Container>

        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>

          <Notification.Footer.Dot />

          <Notification.Footer.Image
            label={
              !!notification?.metadata?.location?.lesson?.lesson_title
                ? "Aula"
                : "Comunidade"
            }
            src={
              notification?.metadata?.location?.lesson?.lesson_thumbnail ??
              notification?.metadata?.location?.group?.group_logo_horizontal
            }
            backgroundColor={
              notification?.metadata?.location?.group?.group_primary_color
            }
          />
        </Notification.Footer.Container>
      </Notification.Container>
    </PrivateNotificationContainer>
  );
};
